// extracted by mini-css-extract-plugin
module.exports = {"listSubHeader":"list-subheader-module__listSubHeader___uiYbF"};